export enum PhysioAssessmentFormVersion {
    ShortAssessment = "ShortAssessment",
    FullAssessment = "FullAssessment"
}
